import script from "./Arrowhead.vue?vue&type=script&setup=true&lang=js"
export * from "./Arrowhead.vue?vue&type=script&setup=true&lang=js"

import "./Arrowhead.vue?vue&type=style&index=0&id=691e0b44&lang=scss"

const __exports__ = script;

export default __exports__